import React from 'react';
import { ScreenOverlay, Spinner } from '@noths/shared-components';

const FullPageSpinner = () => (
  <ScreenOverlay center>
    <Spinner />
  </ScreenOverlay>
);

FullPageSpinner.displayName = 'FullPageSpinner';
export default FullPageSpinner;
